<ng-container *transloco="let t">
  @if (processedVouchersCount() < voucherCreationQueue().length) {
    <pxw-alert type="info" display="inline-block" size="sm" style="margin-bottom: 1.5em">
      <pxw-icon icon="loading" [spin]="true" />
      <span>
        <span>{{ t('Generando facturas: ') }}</span>
        <span>{{ processedVouchersCount() + 1 }} de {{ voucherCreationQueue().length }}</span>
      </span>
    </pxw-alert>
  }
  <table class="ui-table">
    <thead>
      <tr class="ui-table__heading-row">
        <th class="ui-table__heading-col order-column">Pedido</th>
        <th class="ui-table__heading-col status-column">Estado</th>
        <th class="ui-table__heading-col result-column">Resultado</th>
      </tr>
    </thead>
    <tbody>
      @for (item of voucherCreationQueue(); track item.orderId) {
        <tr class="ui-table__body-row">
          <td class="ui-table__body-col order-column">
            <b>{{ getFormattedOrderId(item.orderDetails.sequenceId) }}</b>
          </td>
          <td class="ui-table__body-col status-column">
            <pxw-tag [type]="getTagType(item.status)" size="xs">
              {{ getStatusLabel(item.status) }}
            </pxw-tag>
          </td>
          <td class="ui-table__body-col result-column">
            @if (item.taxVoucherSummary) {
              <span style="white-space: nowrap">
                {{ getVoucherType(item.taxVoucherSummary) }}:
                {{ item.taxVoucherSummary.details.voucherRef }}
              </span>
            } @else if (item.errors) {
              @for (error of item.errors; track error) {
                <p style="margin-bottom: 0.5em">{{ error }}</p>
              }
            }
          </td>
        </tr>
      }
    </tbody>
  </table>
</ng-container>
